import {
  BIND_AGENT,
  BIND_AGENT_SUCCESS,
  BIND_AGENT_ERROR,
  REGISTER_AGENT,
  REGISTER_AGENT_SUCCESS,
  REGISTER_AGENT_ERROR,
  AgentActions,
  ALREADY_GET_NUMBER
} from '../../actions/loyalty/actions-agent';
import { AgentState } from '../../models/loyalty/agent.state';

/* eslint-disable */
function getInitialState(): AgentState {
  return {
    isLoading: false,
    isAlreadyGetNumber: false,
    code: 0,
    data: {
      requestId: '',
      token: '',
      key: '',
      number: 0
    },
    message: '',
    loadingError: ''
  };
}

const initialState: AgentState = getInitialState();

/* eslint-disable */
export function reducersAgent(state = initialState, action: AgentActions): AgentState {
  switch (action.type) {
    case BIND_AGENT:
      return { ...state, isLoading: true, loadingError: '' };

    case BIND_AGENT_SUCCESS:
      return { ...state, ...action.payload, isLoading: false, loadingError: '' };

    case BIND_AGENT_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    case REGISTER_AGENT:
      return { ...state, isLoading: true, loadingError: '' };

    case REGISTER_AGENT_SUCCESS:
      return { ...state, ...action.payload, isLoading: false, loadingError: '' };

    case REGISTER_AGENT_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    case ALREADY_GET_NUMBER:
      return { ...state, isAlreadyGetNumber: action.payload };

    default:
      return state;
  }
}
